import styled, { css } from 'styled-components';
export var LogoTypeWrapper = styled.span.withConfig({
  componentId: "sc-1gvr0i5-0"
})(["margin-left:10.21px;overflow:hidden;"]);
export var LogoTypeSvg = styled.svg.withConfig({
  componentId: "sc-1gvr0i5-1"
})(["", " ", " ", ""], function (_ref) {
  var animated = _ref.animated;
  return animated && css(["transition:transform 500ms,visibility 500ms;"]);
}, function (_ref2) {
  var hide = _ref2.hide;
  return hide && css(["visibility:hidden;"]);
}, function (_ref3) {
  var hide = _ref3.hide,
    animated = _ref3.animated;
  return hide && animated && css(["transition:transform 500ms,visibility 500ms;transform:translateX(-100%);"]);
});
export var StyledLink = styled.a.withConfig({
  componentId: "sc-1gvr0i5-2"
})(["line-height:0;text-decoration:none;&:hover,&:focus{", "{transform:translateX(0);visibility:visible;}}"], LogoTypeSvg);
export var LogoWrapper = styled.div.withConfig({
  componentId: "sc-1gvr0i5-3"
})(["display:flex;"]);